<template>
  <div>
    <div class="flex flex-col sm:flex-row w-full justify-between">
      <p class="text-2xl sm:text-4xl text-slate-800 font-semibold text-center">{{ currentBoard.title }}</p>

      <div class="flex items-center justify-center md:mt-0">
        <!-- <div class="cursor-pointer flex items-center bg-primary rounded-lg gap-2 p-2 mr-2"
          @click.stop="publishBoardModal = !publishBoardModal">
          <div class="border-white border-0 border-r-2 border-solid flex items-center">
            <img src="@/assets/images/icons/planet.svg" class="mr-2" />
          </div>
          <p class="text-xl text-white font-medium mr-2">Publish</p>
        </div> -->

        <div class="vx-col w-full flex justify-between flex-wrap mr-2 mb-2 sm:mb-0"
          style="display: flex; position: relative; align-items: center">
          <div class="flex items-center">
            <div style="float: left">
              <div class="h-12 cursor-pointer flex items-center border-grey-300 border-2 rounded-lg border-solid gap-2"
                @click.stop="inviteUserModal = !inviteUserModal">
                <div class="border-grey-300 border-0 border-r-2 border-solid p-2">
                  <vs-icon icon="icon-plus" class="p-1 rounded-full" size="15px" icon-pack="feather" color="#fff"
                    style="background: #98a2b3" />
                </div>
                <p class="text-xl text-black font-medium p-2 mr-2">Invite</p>
              </div>
            </div>
          </div>
        </div>
        <div class="h-10 border-grey-300 border-0 border-r-2 border-solid flex items-center" />
        <div>
          <!-- <vs-button type="border" style="border-radius: 6px;" icon-pack="feather" icon="icon-activity"></vs-button> -->
        </div>
        <div class="hidden sm:flex items-center ml-2">
          <vx-tooltip text="Board Details" position="bottom" style="display: flex; align-items: baseline"
            class="items-center">
            <feather-icon icon="InfoIcon" color="primary" svgClasses="text-primary" class="cursor-pointer"
              @click="boardInformation = true" />
          </vx-tooltip>
        </div>
        <div class="ml-3">
          <div v-if="boardView === 'kanban'" class="p-2 board-view-btn btn-active cursor-pointer">
            <vx-tooltip text="Kanban" position="bottom" style="display: flex; align-items: baseline"
              class="items-center">
              <feather-icon icon="TrelloIcon" svgClasses="w-5 h-5" style="color: #ffffff" />
            </vx-tooltip>
          </div>
          <div v-else class="p-2 board-view-btn btn-inactive cursor-pointer"
            @click.stop="setBoardView(boardView, 'kanban')">
            <vx-tooltip text="Kanban" position="bottom" style="display: flex; align-items: baseline"
              class="items-center">
              <feather-icon icon="TrelloIcon" svgClasses="w-5 h-5" class="text-primary" />
            </vx-tooltip>
          </div>
        </div>
        <div class="flex ml-3">
          <div v-if="boardView === 'grid' || boardView === 'kanban'">
            <div v-if="boardView === 'grid'" class="p-2 board-view-btn btn-active cursor-pointer"
              @click.stop="setBoardView(boardView, 'tabular')">
              <vx-tooltip text="Switch to Tabular View" position="bottom" style="display: flex; align-items: baseline"
                class="items-center">
                <feather-icon icon="GridIcon" svgClasses="w-4 h-4" style="color: #ffffff" />
              </vx-tooltip>
            </div>
            <div v-else class="p-2 board-view-btn btn-inactive cursor-pointer"
              @click.stop="setBoardView(boardView, 'grid')">
              <vx-tooltip text="Grid View" position="bottom" style="display: flex; align-items: baseline"
                class="items-center">
                <feather-icon icon="GridIcon" svgClasses="w-4 h-4" class="text-primary" />
              </vx-tooltip>
            </div>
          </div>
          <div v-else>
            <div class="p-2 board-view-btn btn-active cursor-pointer" @click.stop="setBoardView(boardView, 'tabular')">
              <vx-tooltip text="Switch to Grid View" position="bottom" style="display: flex; align-items: baseline"
                class="items-center">
                <feather-icon icon="ListIcon" svgClasses="w-4 h-4" style="color: #ffffff" />
              </vx-tooltip>
            </div>
          </div>

          <!-- <vs-button :type="(currentBoard.view === 'kanban')?'filled':'border'" class="ml-1" style="border-radius: 6px;" icon-pack="feather" icon="icon-sidebar"></vs-button> -->
        </div>
        <div class="ml-3 items-center" style="justify-content: center">
          <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
            <div class="flex border-grey-300 border-2 rounded-lg border-solid p-2">
              <feather-icon icon="MoreVerticalIcon" svgClasses="w-6 h-6" class="text-grey" />
            </div>

            <vs-dropdown-menu>
              <!-- <vs-dropdown-item v-if="!currentBoard.rktChannelId" @click.stop="connectWithCommServer" style="min-width: 11rem; font-size: 14.5px;">
                  Connect with Comm Server
                </vs-dropdown-item> -->
              <!-- <vs-dropdown-item @click.stop="syncBoardChannel" style="min-width: 11rem; font-size: 14.5px;">
                  Sync with Comm Server
                </vs-dropdown-item> -->
              <vs-dropdown-item :to="{ name: 'org-boards-edit' }" style="min-width: 11rem; font-size: 14.5px">
                Edit Board Details
              </vs-dropdown-item>
              <vs-dropdown-item @click.stop="deactivationConfirmPrompt = true" divider
                style="min-width: 11rem; font-size: 14.5px">
                Deactivate Board
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
      </div>
    </div>
    <div class="my-5 border-solid border-l-0 border-r-0 border-t-0 border-b-1 border-slate-200" />
    <div @click="inviteUserModal = false">
      <!-- <div class="items-center" v-if="!processingMode && monthDiff(new Date(this.currentBoard.createdAt), new Date())">
        <div class="w-full lg:w-1/2" style="margin-top: 10rem;">
          <vx-card class="org-card mt-base">
            <img class="mb-base" src="@/assets/images/boards/board-expired.svg" width="150px" />
            <h3 class="font-bold">This Board has Expired</h3>
          </vx-card>
        </div>
      </div> -->
      <div v-if="!processingMode">
        <!-- <h3 class="mb-base">{{ currentBoard.title }}</h3> -->
        <div class="vx-row">
          <!-- Update User Prompt -->
          <vs-prompt class="invite-user-prompt" title="Update User Details" @cancel="cancelForm" @accept="updateUser"
            :accept-text="'Update'" :is-valid="validForm" :active="activeUpdateUserPrompt" color="primary"
            ref="updateUserPrompt">
            <div class="invitee-form">
              <div class="details--heading" style="margin: 1rem 0 2rem 0">
                <span>Invitee Details</span>
              </div>
              <vs-row class="mb-base">
                <vs-col class="px-2" vs-w="4" vs-xs="12">
                  <label>Email<span class="text-danger">*</span></label>
                  <vs-input class="w-full invitee-form-input" name="Email" data-vv-validate-on="blur"
                    v-validate="'required|email'" v-model="localData.email" @input="userExists()" :disabled="true" />
                  <span class="text-danger text-sm">{{
                    errors.first("Email")
                  }}</span>
                </vs-col>
                <vs-col class="px-2" vs-w="4" vs-xs="12">
                  <label>First Name<span class="text-danger">*</span></label>
                  <vs-input class="w-full invitee-form-input" name="First Name" data-vv-validate-on="blur"
                    v-validate="'required'" v-model="localData.firstName" :disabled="inviteFormDisabled" />
                  <span class="text-danger text-sm">{{
                    errors.first("First Name")
                  }}</span>
                </vs-col>
                <vs-col class="px-2" vs-w="4" vs-xs="12">
                  <label>Last Name<span class="text-danger">*</span></label>
                  <vs-input class="w-full invitee-form-input" name="Last Name" data-vv-validate-on="blur"
                    v-validate="'required'" v-model="localData.lastName" :disabled="inviteFormDisabled" />
                  <span class="text-danger text-sm">{{
                    errors.first("Last Name")
                  }}</span>
                </vs-col>
              </vs-row>
              <!-- <div
                v-if="isAlexInstalled"
                class="details--heading"
                style="margin: 3rem 0 2rem 0"
              >
                <span>Invitee Details Required by Alex</span>
              </div> -->
              <vs-row class="mb-base">
                <vs-col class="px-2" vs-w="4" vs-xs="12">
                  <label>Primary Language<span class="text-danger">*</span></label>
                  <!-- <vs-input
                    class="w-full invitee-form-input"
                    name="Language"
                    placeholder="Enter Language"
                    data-vv-validate-on="blur"
                    v-validate="'required'"
                    v-model="localData.language"
                  /> -->
                  <v-select class="w-full invitee-form-input" name="Primary Language"
                    :class="isLanguagePresent ? '' : 'english-select'" v-model="localData.primaryLanguage"
                    :options="languageOptions" :disabled="inviteFormDisabled" @input.native="isLanguageTyped" />
                  <span class="text-danger text-sm">{{
                    errors.first("Primary Language")
                  }}</span>
                </vs-col>
                <vs-col class="px-2" vs-w="4" vs-xs="12">
                  <label>Current Location<span class="text-danger">*</span></label>
                  <!-- <vs-input
                    class="w-full invitee-form-input"
                    name="Country"
                    data-vv-validate-on="blur"
                    v-validate="'required'"
                    v-model="localData.country"
                  /> -->
                  <v-select class="w-full invitee-form-input" name="Current Location"
                    v-model="localData.currentLocation" :options="countryOptions" :disabled="inviteFormDisabled" />
                  <span class="text-danger text-sm">{{
                    errors.first("Current Location")
                  }}</span>
                </vs-col>
                <vs-col class="px-2" vs-w="4" vs-xs="12">
                  <label>Gender</label>
                  <!-- <vs-input
                      class="w-full invitee-form-input"
                      name="Date of Birth"
                      type="date"
                      v-model="localData.dob"
                      :disabled="inviteFormDisabled"
                    />
                    <span class="text-danger text-sm">{{
                      errors.first("Date of Birth")
                    }}</span> -->
                  <vs-row class="mt-3">
                    <vs-radio class="mr-5" name="Gender" v-model="localData.gender" vs-value="female"
                      :disabled="inviteFormDisabled"><vx-tooltip text="Female" position="bottom"><img
                          src="@/assets/images/icons/gender/female.svg" width="20px" height="20px"
                          alt="" /></vx-tooltip></vs-radio>
                    <vs-radio class="mr-5" name="Gender" v-model="localData.gender" vs-value="male"
                      :disabled="inviteFormDisabled"><vx-tooltip text="Male" position="bottom"><img
                          src="@/assets/images/icons/gender/male.svg" width="20px" height="20px"
                          alt="" /></vx-tooltip></vs-radio>
                    <vs-radio name="Gender" v-model="localData.gender" vs-value="other"
                      :disabled="inviteFormDisabled"><vx-tooltip text="Other" position="bottom"><img
                          src="@/assets/images/icons/gender/circle-ring.svg" width="20px" height="20px"
                          alt="" /></vx-tooltip></vs-radio>
                  </vs-row>
                </vs-col>
              </vs-row>
              <!-- <div
                v-if="isAlexInstalled && alexAppConfig && organizationConfiguration && Object.keys(organizationConfiguration).length"
                class="details--heading"
                style="margin: 3rem 0 2rem 0"
              >
                <span>Invitee Details Required by Alex</span>
              </div> -->
              <vs-row v-if="
                organizationConfiguration &&
                Object.keys(organizationConfiguration).length
              " class="mb-base">
                <vs-col class="px-2" vs-w="4" vs-xs="12">
                  <label>{{
                    organizationConfiguration.department.title
                  }}</label>
                  <!-- <vs-input
                    v-if="orgData.slug !== 'gala'"
                    class="w-full invitee-form-input"
                    name="Department"
                    v-model="localData.department"
                    :disabled="inviteFormDisabled"
                  /> -->
                  <v-select class="w-full invitee-form-input" :name="organizationConfiguration.department.title"
                    v-model="localData.department" :options="organizationConfiguration.department.values"
                    :disabled="inviteFormDisabled" />
                  <span class="text-danger text-sm">{{
                    errors.first(organizationConfiguration.department.title)
                  }}</span>
                </vs-col>
                <vs-col class="px-2" vs-w="4" vs-xs="12">
                  <label>{{ organizationConfiguration.roleTitle.title }}</label>
                  <v-select class="w-full invitee-form-input" name="Role Title" v-model="localData.roleTitle"
                    :options="organizationConfiguration.roleTitle.values" :disabled="inviteFormDisabled" />
                  <span class="text-danger text-sm">{{
                    errors.first(organizationConfiguration.roleTitle.title)
                  }}</span>
                </vs-col>
                <vs-col class="px-2" vs-w="4" vs-xs="12">
                  <label>{{ organizationConfiguration.level.title }}</label>
                  <v-select class="w-full invitee-form-input" :name="organizationConfiguration.level.title"
                    v-model="localData.level" :options="organizationConfiguration.level.values"
                    :disabled="inviteFormDisabled" />
                  <span class="text-danger text-sm">{{
                    errors.first(organizationConfiguration.level.title)
                  }}</span>
                </vs-col>
              </vs-row>
              <vs-row v-if="
                organizationConfiguration &&
                Object.keys(organizationConfiguration).length
              " class="mb-base">
                <vs-col class="px-2" vs-w="4" vs-xs="12">
                  <label>{{
                    organizationConfiguration.numberOfDirectReports.title
                  }}</label>
                  <vs-input class="w-full invitee-form-input" type="number" :name="organizationConfiguration.numberOfDirectReports.title
                    " v-model="localData.numberOfDirectReports" :disabled="inviteFormDisabled" min="0" />
                  <span class="text-danger text-sm">{{
                    errors.first(
                      organizationConfiguration.numberOfDirectReports.title
                    )
                  }}</span>
                </vs-col>
                <vs-col class="px-2" vs-w="4" vs-xs="12">
                  <label>{{
                    organizationConfiguration.performance.title
                  }}</label>
                  <v-select class="w-full invitee-form-input" :name="organizationConfiguration.performance.title"
                    v-model="localData.performance" :options="organizationConfiguration.performance.values"
                    :disabled="inviteFormDisabled" />
                  <span class="text-danger text-sm">{{
                    errors.first(organizationConfiguration.performance.title)
                  }}</span>
                </vs-col>
                <vs-col class="px-2" vs-w="4" vs-xs="12">
                  <label>{{ organizationConfiguration.potential.title }}</label>
                  <v-select class="w-full invitee-form-input" :name="organizationConfiguration.potential.title"
                    v-model="localData.potential" :options="organizationConfiguration.potential.values"
                    :disabled="inviteFormDisabled" />
                  <span class="text-danger text-sm">{{
                    errors.first(organizationConfiguration.potential.title)
                  }}</span>
                </vs-col>
              </vs-row>
              <div v-if="isCoachInstalled" class="details--heading" style="margin: 3rem 0 2rem 0">
                <span>Invitee Details Required by Coach </span>
              </div>
              <vs-row v-if="isCoachInstalled" class="mb-base">
                <vs-col class="px-2" vs-w="4" vs-xs="12">
                  <label>User Type<span class="text-danger">*</span></label>
                  <v-select class="w-full invitee-form-input" name="Performance" v-model="localData.userType" :options="orgData && orgData.slug === 'gala'
                    ? ['mentor', 'player']
                    : ['coach', 'trainee']
                    " :disabled="inviteFormDisabled" />
                  <span class="text-danger text-sm">{{
                    errors.first("Performance")
                  }}</span>
                </vs-col>
              </vs-row>
            </div>
          </vs-prompt>

          <!-- Invite User Prompt -->
          <vs-prompt class="invite-user-prompt" :title="isNewOrgBoard === true
            ? `Add Yourself to ${currentBoard.title}`
            : `Invite User to ${currentBoard.title}`
            " @cancel="cancelForm" @accept="addUserToBoard" accept-text="Invite" :is-valid="validForm"
            :active="activeInviteUserPrompt" color="primary" ref="inviteUserPrompt">
            <div class="invitee-form">
              <div class="details--heading" style="margin: 1rem 0 2rem 0">
                <span>Invitee Details</span>
              </div>
              <vs-row class="mb-base">
                <vs-col class="px-2" vs-w="4" vs-xs="12">
                  <label>Email<span class="text-danger">*</span></label>
                  <vs-input class="w-full invitee-form-input" name="Email" data-vv-validate-on="blur"
                    v-validate="'required|email'" v-model="localData.email" @input="userExists()" />
                  <span v-if="userAlreadyExists" class="text-danger text-sm">User/Email already exists in the current
                    board.</span>
                  <span v-else-if="userAlreadyExistsInOtherBoard" class="text-success text-sm">User/Email exists &
                    it's
                    data has been
                    auto-populated.</span>
                  <span v-if="userFoundInHibob" class="text-success text-sm">User/Email found in Hibob & it's data has
                    been
                    auto-populated.</span>
                  <span class="text-danger text-sm">{{
                    errors.first("Email")
                  }}</span>
                </vs-col>
                <vs-col class="px-2" vs-w="4" vs-xs="12">
                  <label>First Name<span class="text-danger">*</span></label>
                  <vs-input class="w-full invitee-form-input" name="First Name" data-vv-validate-on="blur"
                    v-validate="'required'" v-model="localData.firstName" :disabled="inviteFormDisabled" />
                  <span class="text-danger text-sm">{{
                    errors.first("First Name")
                  }}</span>
                </vs-col>
                <vs-col class="px-2" vs-w="4" vs-xs="12">
                  <label>Last Name<span class="text-danger">*</span></label>
                  <vs-input class="w-full invitee-form-input" name="Last Name" data-vv-validate-on="blur"
                    v-validate="'required'" v-model="localData.lastName" :disabled="inviteFormDisabled" />
                  <span class="text-danger text-sm">{{
                    errors.first("Last Name")
                  }}</span>
                </vs-col>
              </vs-row>
              <!-- <div
                v-if="isAlexInstalled"
                class="details--heading"
                style="margin: 3rem 0 2rem 0"
              >
                <span>Invitee Details Required by Alex</span>
              </div> -->
              <vs-row class="mb-base">
                <vs-col class="px-2" vs-w="4" vs-xs="12">
                  <label>Primary Language<span class="text-danger">*</span></label>
                  <!-- <vs-input
                    class="w-full invitee-form-input"
                    name="Language"
                    placeholder="Enter Language"
                    data-vv-validate-on="blur"
                    v-validate="'required'"
                    v-model="localData.language"
                  /> -->

                  <v-select class="w-full invitee-form-input" name="Primary Language"
                    :class="isLanguagePresent ? '' : 'english-select'" v-model="localData.primaryLanguage"
                    :options="languageOptions" @input.native="isLanguageTyped">
                  </v-select>
                  <span class="text-danger text-sm">{{
                    errors.first("Primary Language")
                  }}</span>
                </vs-col>
                <vs-col class="px-2" vs-w="4" vs-xs="12">
                  <label>Current Location<span class="text-danger">*</span></label>
                  <!-- <vs-input
                    class="w-full invitee-form-input"
                    name="Country"
                    data-vv-validate-on="blur"
                    v-validate="'required'"
                    v-model="localData.country"
                  /> -->
                  <v-select class="w-full invitee-form-input" name="Current Location"
                    v-model="localData.currentLocation" :options="countryOptions" />
                  <span class="text-danger text-sm">{{
                    errors.first("Current Location")
                  }}</span>
                </vs-col>
                <vs-col class="px-2" vs-w="4" vs-xs="12">
                  <label>Gender</label>
                  <!-- <vs-input
                      class="w-full invitee-form-input"
                      name="Date of Birth"
                      type="date"
                      v-model="localData.dob"

                    /> -->
                  <!-- <span class="text-danger text-sm">{{
                      errors.first("Date of Birth")
                    }}</span> -->
                  <vs-row class="mt-3">
                    <vs-radio class="mr-5" name="Gender" v-model="localData.gender" vs-value="female"
                      :disabled="inviteFormDisabled"><vx-tooltip text="Female" position="bottom"><img
                          src="@/assets/images/icons/gender/female.svg" width="20px" height="20px"
                          alt="" /></vx-tooltip></vs-radio>
                    <vs-radio class="mr-5" name="Gender" v-model="localData.gender" vs-value="male"
                      :disabled="inviteFormDisabled"><vx-tooltip text="Male" position="bottom"><img
                          src="@/assets/images/icons/gender/male.svg" width="20px" height="20px"
                          alt="" /></vx-tooltip></vs-radio>
                    <vs-radio name="Gender" v-model="localData.gender" vs-value="other"
                      :disabled="inviteFormDisabled"><vx-tooltip text="Other" position="bottom"><img
                          src="@/assets/images/icons/gender/circle-ring.svg" width="20px" height="20px"
                          alt="" /></vx-tooltip></vs-radio>
                  </vs-row>
                </vs-col>
              </vs-row>
              <!-- <div
                v-if="organizationConfiguration && Object.keys(organizationConfiguration).length"
                class="details--heading"
                style="margin: 3rem 0 2rem 0"
              >
                <span>Invitee Details Required by Alex</span>
              </div> -->
              <vs-row v-if="
                organizationConfiguration &&
                Object.keys(organizationConfiguration).length
              " class="mb-base">
                <vs-col class="px-2" vs-w="4" vs-xs="12">
                  <label>{{
                    organizationConfiguration.department.title
                  }}</label>
                  <!-- <vs-input
                    v-if="orgData.slug !== 'gala'"
                    class="w-full invitee-form-input"
                    name="Department"
                    v-model="localData.department"
                  /> -->
                  <v-select class="w-full invitee-form-input" name="Level" v-model="localData.department"
                    :options="organizationConfiguration.department.values" :disabled="inviteFormDisabled" />
                  <span class="text-danger text-sm">{{
                    errors.first("Department")
                  }}</span>
                </vs-col>
                <vs-col class="px-2" vs-w="4" vs-xs="12">
                  <label>{{ organizationConfiguration.roleTitle.title }}</label>
                  <v-select class="w-full invitee-form-input" name="Role Title" v-model="localData.roleTitle"
                    :options="organizationConfiguration.roleTitle.values" :disabled="inviteFormDisabled" />
                  <span class="text-danger text-sm">{{
                    errors.first("Role Title")
                  }}</span>
                </vs-col>
                <vs-col class="px-2" vs-w="4" vs-xs="12">
                  <label>{{ organizationConfiguration.level.title }}</label>
                  <v-select class="w-full invitee-form-input" name="Level" v-model="localData.level"
                    :options="organizationConfiguration.level.values" />
                  <span class="text-danger text-sm">{{
                    errors.first("Level")
                  }}</span>
                </vs-col>
              </vs-row>
              <vs-row v-if="
                organizationConfiguration &&
                Object.keys(organizationConfiguration).length
              " class="mb-base">
                <vs-col class="px-2" vs-w="4" vs-xs="12">
                  <label>{{
                    organizationConfiguration.numberOfDirectReports.title
                  }}</label>
                  <vs-input class="w-full invitee-form-input" type="number" name="Number of Direct Reports"
                    v-model="localData.numberOfDirectReports" />
                  <span class="text-danger text-sm">{{
                    errors.first("Number of Direct Reports")
                  }}</span>
                </vs-col>
                <vs-col class="px-2" vs-w="4" vs-xs="12">
                  <label>{{
                    organizationConfiguration.performance.title
                  }}</label>
                  <v-select class="w-full invitee-form-input" name="Performance" v-model="localData.performance"
                    :options="organizationConfiguration.performance.values" />
                  <span class="text-danger text-sm">{{
                    errors.first("Performance")
                  }}</span>
                </vs-col>
                <vs-col class="px-2" vs-w="4" vs-xs="12">
                  <label>{{ organizationConfiguration.potential.title }}</label>
                  <v-select class="w-full invitee-form-input" name="Potential" v-model="localData.potential"
                    :options="organizationConfiguration.potential.values" />
                  <span class="text-danger text-sm">{{
                    errors.first("Potential")
                  }}</span>
                </vs-col>
              </vs-row>
              <div v-if="isCoachInstalled" class="details--heading" style="margin: 3rem 0 2rem 0">
                <span>Invitee Details Required by Coach</span>
              </div>
              <vs-row v-if="isCoachInstalled" class="mb-base">
                <vs-col class="px-2" vs-w="4" vs-xs="12">
                  <label>User Type<span class="text-danger">*</span></label>
                  <v-select class="w-full invitee-form-input" name="Performance" v-model="localData.userType" :options="orgData && orgData.slug === 'gala'
                    ? ['mentor', 'player']
                    : ['coach', 'trainee']
                    " :disabled="inviteFormDisabled" />
                  <span class="text-danger text-sm">{{
                    errors.first("Performance")
                  }}</span>
                </vs-col>
              </vs-row>
            </div>
          </vs-prompt>

          <!-- Assign Coach Prompt -->
          <vs-prompt color="primary" class="deactivate-board-prompt" :title="orgData && orgData.slug === 'gala'
            ? 'Assign Mentor'
            : 'Assign Coach'
            " @cancel="resetForm" @accept="assignCoach" @close="resetForm" accept-text="Assign"
            :is-valid="isAssignCoachValid" :active.sync="assignCoachConfirmPrompt">
            <div v-if="assignedTraineeId" id="assign-coach-loading" class="mb-4 vss-con-loading__container">
              <div class="mb-base">
                <div class="font-bold">
                  <div class="font-bold">
                    {{
                      orgData && orgData.slug === "gala" ? "Player" : "Trainee"
                    }}
                  </div>
                </div>
                <span>{{ getUserDataById(assignedTraineeId).userData.firstName }}
                  {{
                    getUserDataById(assignedTraineeId).userData.lastName
                  }}</span>
              </div>
              <div>
                <div class="font-bold">
                  {{ orgData && orgData.slug === "gala" ? "Mentor" : "Coach" }}
                </div>
                <v-select class="w-full" name="coach-asignee" v-model="coachSelected" :options="allCoaches" />
              </div>
            </div>
          </vs-prompt>

          <vs-popup title="Board Details" :active.sync="boardInformation">
            <div v-if="availableCredits || currentBoard.numberOfUsers" class="flex justify-between mb-base">
              <p class="font-semibold">Available Credits</p>
              <span>{{
                availableCredits
                  ? availableCredits
                  : Number(currentBoard.numberOfUsers) -
                  Number(currentBoardUsers.length)
              }}</span>
            </div>

            <div class="flex mb-base justify-between">
              <p class="font-semibold">Non-Expiry Board</p>
              <span v-if="currentBoard.perpetuality">Yes</span>
              <span v-else>No</span>
            </div>
            <div v-if="currentBoard.numberOfMonths && !currentBoard.perpetuality" class="flex mb-base justify-between">
              <p class="font-semibold">Total Duration</p>
              <span>{{ currentBoard.numberOfMonths }} Month(s)</span>
            </div>

            <div v-if="currentBoard.skill && currentBoard.skill.length" class="float-left mb-base w-full">
              <h5 class="mb-3">Skills</h5>
              <div v-for="(skill, index) in currentBoard.skill" :key="index">
                <vs-chip>{{ skill }}</vs-chip>
              </div>
            </div>

            <div v-if="currentBoard.personality && currentBoard.personality.length" class="float-left mb-base w-full">
              <h5 class="mb-3">Personality</h5>
              <div v-for="(personality, index) in currentBoard.personality" :key="index">
                <vs-chip>{{ personality }}</vs-chip>
              </div>
            </div>

            <div v-if="currentBoard.description" class="float-left mb-base w-full">
              <h5 class="mb-3">Description</h5>
              <div v-html="currentBoard.description"></div>
            </div>
          </vs-popup>

          <div class="vx-col w-full mb-base flex justify-between flex-wrap hidden"
            style="display: flex; position: relative; align-items: center">
            <div class="flex">
              <div style="float: left">
                <vs-button class="invite-user-btn" @click.stop="activeInviteUserPrompt = true" :disabled="Number(currentBoard.numberOfUsers) <=
                  currentBoardUsers.length
                  ">Invite User</vs-button>
              </div>
              <div class="flex items-center ml-3">
                <vx-tooltip :text="isLinkCopied
                  ? 'Board invite link copied'
                  : 'Click to copy board invite link'
                  " position="bottom" style="display: flex; align-items: baseline" class="items-center">
                  <vs-button type="line" icon-pack="feather" icon="icon-link" style="border-radius: 0px"
                    @click="copyBoardInviteLink()" :disabled="Number(currentBoard.numberOfUsers) <=
                      currentBoardUsers.length
                      "></vs-button>
                </vx-tooltip>
              </div>
              <!-- <div class="flex items-center ml-3">
                <vx-tooltip
                  text="Upload an excel of users to be invited"
                  position="bottom"
                  style="display: flex; align-items: baseline"
                  class="items-center"
                >
                  <vs-button
                    type="line"
                    icon-pack="feather"
                    icon="icon-upload"
                    style="border-radius: 0px"
                    @click="$refs.upload_invitee_excel_input.click()"
                    :disabled="
                      Number(currentBoard.numberOfUsers) <=
                      currentBoardUsers.length
                    "
                  ></vs-button>
                </vx-tooltip>
                <input
                  :disabled="
                    Number(currentBoard.numberOfUsers) <=
                    currentBoardUsers.length
                  "
                  type="file"
                  class="hidden"
                  name="Invitee_Excel_Input"
                  ref="upload_invitee_excel_input"
                  @change="uploadInviteeExcel"
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                />
              </div> -->
              <div class="flex items-center ml-3">
                <vx-tooltip text="Parse resume to invite user" position="bottom"
                  style="display: flex; align-items: baseline" class="items-center">
                  <vs-button type="line" icon-pack="feather" icon="icon-file-text" style="border-radius: 0px"
                    @click="parseResume()" :disabled="Number(currentBoard.numberOfUsers) <=
                      currentBoardUsers.length
                      "></vs-button>
                </vx-tooltip>
              </div>
              <div class="installed-apps">
                <ul class="installed-apps-list ml-base">
                  <li v-for="(appId, index) in currentBoard.installedApps" :key="index">
                    <vx-tooltip v-if="appId === 'coach'" :text="appId === 'coach' && orgData.slug === 'gala'
                      ? 'Mentor'
                      : 'Coach'
                      " position="bottom">
                      <div class="format-icon">
                        <img width="32px" :src="require(`@/assets/images/icons/app-marketplace-colored/${appId}.svg`)
                          " />
                      </div>
                    </vx-tooltip>

                    <vx-tooltip v-else :text="getAppDataById(appId).title" position="bottom">
                      <div class="format-icon">
                        <img width="32px" :src="require(`@/assets/images/icons/app-marketplace-colored/${appId}.svg`)
                          " />
                      </div>
                    </vx-tooltip>
                  </li>
                </ul>
              </div>
            </div>
            <div class="flex items-center">
              <div>
                <!-- <vs-button type="border" style="border-radius: 6px;" icon-pack="feather" icon="icon-activity"></vs-button> -->
              </div>
              <div class="flex items-center ml-3">
                <vx-tooltip text="Board Details" position="bottom" style="display: flex; align-items: baseline"
                  class="items-center">
                  <feather-icon icon="InfoIcon" color="primary" svgClasses="text-primary" class="cursor-pointer"
                    @click="boardInformation = true" />
                </vx-tooltip>
              </div>
              <div class="ml-3">
                <div v-if="boardView === 'kanban'" class="p-2 board-view-btn btn-active cursor-pointer">
                  <vx-tooltip text="Kanban" position="bottom" style="display: flex; align-items: baseline"
                    class="items-center">
                    <feather-icon icon="TrelloIcon" svgClasses="w-5 h-5" style="color: #ffffff" />
                  </vx-tooltip>
                </div>
                <div v-else class="p-2 board-view-btn btn-inactive cursor-pointer"
                  @click.stop="setBoardView(boardView, 'kanban')">
                  <vx-tooltip text="Kanban" position="bottom" style="display: flex; align-items: baseline"
                    class="items-center">
                    <feather-icon icon="TrelloIcon" svgClasses="w-5 h-5" class="text-primary" />
                  </vx-tooltip>
                </div>
              </div>
              <div class="flex ml-3">
                <div v-if="boardView === 'grid' || boardView === 'kanban'">
                  <div v-if="boardView === 'grid'" class="p-2 board-view-btn btn-active cursor-pointer"
                    @click.stop="setBoardView(boardView, 'tabular')">
                    <vx-tooltip text="Switch to Tabular View" position="bottom"
                      style="display: flex; align-items: baseline" class="items-center">
                      <feather-icon icon="GridIcon" svgClasses="w-4 h-4" style="color: #ffffff" />
                    </vx-tooltip>
                  </div>
                  <div v-else class="p-2 board-view-btn btn-inactive cursor-pointer"
                    @click.stop="setBoardView(boardView, 'grid')">
                    <vx-tooltip text="Grid View" position="bottom" style="display: flex; align-items: baseline"
                      class="items-center">
                      <feather-icon icon="GridIcon" svgClasses="w-4 h-4" class="text-primary" />
                    </vx-tooltip>
                  </div>
                </div>
                <div v-else>
                  <div class="p-2 board-view-btn btn-active cursor-pointer"
                    @click.stop="setBoardView(boardView, 'tabular')">
                    <vx-tooltip text="Switch to Grid View" position="bottom"
                      style="display: flex; align-items: baseline" class="items-center">
                      <feather-icon icon="ListIcon" svgClasses="w-4 h-4" style="color: #ffffff" />
                    </vx-tooltip>
                  </div>
                </div>

                <!-- <vs-button :type="(currentBoard.view === 'kanban')?'filled':'border'" class="ml-1" style="border-radius: 6px;" icon-pack="feather" icon="icon-sidebar"></vs-button> -->
              </div>
              <div class="ml-3 items-center" style="justify-content: center">
                <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
                  <a class="a-icon cursor-pointer" href="#">
                    <!-- <vs-avatar size="38px" class="cursor-pointer" color="primary" icon-pack="feather" icon="icon-more-vertical" /> -->
                    <vs-button style="border-radius: 6px" icon-pack="feather" icon="icon-more-vertical"></vs-button>
                  </a>

                  <vs-dropdown-menu>
                    <!-- <vs-dropdown-item v-if="!currentBoard.rktChannelId" @click.stop="connectWithCommServer" style="min-width: 11rem; font-size: 14.5px;">
                        Connect with Comm Server
                      </vs-dropdown-item> -->
                    <!-- <vs-dropdown-item @click.stop="syncBoardChannel" style="min-width: 11rem; font-size: 14.5px;">
                        Sync with Comm Server
                      </vs-dropdown-item> -->
                    <vs-dropdown-item :to="{ name: 'org-boards-edit' }" style="min-width: 11rem; font-size: 14.5px">
                      Edit Board Details
                    </vs-dropdown-item>
                    <vs-dropdown-item @click.stop="deactivationConfirmPrompt = true" divider
                      style="min-width: 11rem; font-size: 14.5px">
                      Deactivate Board
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>
            </div>
          </div>

          <!-- invite user  -->
          <div class="flex items-center">
            <div style="float: left">
              <!-- <div class="h-12 cursor-pointer flex items-center border-grey-300 border-2 rounded-lg border-solid gap-2"
                @click.stop="inviteUserModal = !inviteUserModal">
                <div class="border-grey-300 border-0 border-r-2 border-solid p-2">
                  <vs-icon icon="icon-plus" class="p-1 rounded-full" size="15px" icon-pack="feather" color="#fff"
                    style="background: #98a2b3" />
                </div>
                <p class="text-xl text-black font-medium p-2 mr-2">Invite</p>
              </div> -->

              <!-- invite user modal -->
              <vs-popup title="Invite to board" :active.sync="inviteUserModal" class="invite-board-popup">
                <div class="px-4 py-2">
                  
                  <!-- Share Link -->
                  <p class="text-base font-bold text-gray-800 mb-3 mt-3">Shareable Invite Link</p>
                  <div class="flex items-center gap-2 mb-6">
                    <input 
                      type="text" 
                      :value="`${constants.url}/board/invite/${currentBoard.slug}`"
                      readonly
                      class="flex-1 px-4 py-3 text-sm text-gray-700 border border-gray-200 rounded-lg bg-gray-50 cursor-not-allowed focus:outline-none"
                    />
                    <vx-tooltip text="Copy Link">
                      <feather-icon icon="CopyIcon" color="#667085" class="cursor-pointer hover:text-primary transition w-5 h-5"
                        @click="copyBoardInviteLink()" />
                    </vx-tooltip>
                  </div>

                  <!-- TABS -->
                  <div class="flex w-full border-b border-gray-200 mb-6">
                    <div class="flex-1 pb-3 text-sm font-medium text-center cursor-pointer border-b-2 transition-colors duration-200"
                      :class="activeInviteTab === 'manual' ? 'border-primary text-primary' : 'border-transparent text-gray-400 hover:text-gray-700'"
                      @click="activeInviteTab = 'manual'">
                      Add Manually
                    </div>
                    <div class="flex-1 pb-3 text-sm font-medium text-center cursor-pointer border-b-2 transition-colors duration-200"
                      :class="activeInviteTab === 'board' ? 'border-primary text-primary' : 'border-transparent text-gray-400 hover:text-gray-700'"
                      @click="activeInviteTab = 'board'">
                      From Board
                    </div>
                    <div class="flex-1 pb-3 text-sm font-medium text-center cursor-pointer border-b-2 transition-colors duration-200"
                      :class="activeInviteTab === 'import' ? 'border-primary text-primary' : 'border-transparent text-gray-400 hover:text-gray-700'"
                      @click="activeInviteTab = 'import'">
                      Import
                    </div>
                  </div>

                  <!-- TAB CONTENT -->
                  <div class="min-h-[160px]">
                    
                    <!-- Tab 1: Manual Add -->
                    <div v-if="activeInviteTab === 'manual'" class="flex flex-col gap-4">
                      <div>
                        <input class="w-full px-4 py-3 text-sm text-gray-800 border border-gray-300 rounded-lg outline-none focus:border-primary transition-colors bg-white" 
                          :class="userErrors.email || userErrors.isEmailValid ? 'border-red-500 bg-red-50' : ''" 
                          placeholder="name@company.com" v-model="user.email" @input="autoFetchUser" />
                        <p v-if="userErrors.email" class="text-xs text-red-500 mt-1 m-0">Enter email</p>
                        <p v-if="userErrors.isEmailValid" class="text-xs text-red-500 mt-1 m-0">Enter valid email</p>
                      </div>
                      
                      <div class="flex gap-4">
                        <div class="w-full">
                          <input class="w-full px-4 py-3 text-sm text-gray-800 border border-gray-300 rounded-lg outline-none focus:border-primary transition-colors bg-white" 
                            :class="userErrors.firstName ? 'border-red-500 bg-red-50' : ''" placeholder="First Name" v-model="user.firstName" />
                          <p v-if="userErrors.firstName" class="text-xs text-red-500 mt-1 m-0">Required</p>
                        </div>
                        <div class="w-full">
                          <input class="w-full px-4 py-3 text-sm text-gray-800 border border-gray-300 rounded-lg outline-none focus:border-primary transition-colors bg-white" 
                            :class="userErrors.lastName ? 'border-red-500 bg-red-50' : ''" placeholder="Last Name" v-model="user.lastName" />
                          <p v-if="userErrors.lastName" class="text-xs text-red-500 mt-1 m-0">Required</p>
                        </div>
                      </div>
                      
                      <div class="flex justify-start mt-1">
                        <vs-button type="border" size="small" icon-pack="feather" icon="icon-plus" class="rounded-lg font-medium"
                          @click="addUsersForInvite"
                          :color="orgData.primaryThemeColor">
                          Add to list
                        </vs-button>
                      </div>
                    </div>

                    <!-- Tab 2: From Board -->
                    <div v-if="activeInviteTab === 'board'" class="flex flex-col gap-3">
                      <p class="text-sm text-gray-600 m-0">Select an existing board to import its users:</p>
                      <v-select class="w-full text-base bg-white border border-gray-100 rounded-lg" name="Board name" placeholder="Search Boards..."
                        :options="boardOptions" v-model="boardSelected"></v-select>
                    </div>

                    <!-- Tab 3: Import -->
                    <div v-if="activeInviteTab === 'import'" class="flex flex-col gap-4">
                      <p class="text-sm text-gray-600 m-0">Connect to your workspace apps to import users:</p>
                      <div class="flex items-center gap-5">
                        <vx-tooltip text="Import from Slack">
                          <img class="cursor-pointer w-12 h-12 border border-gray-200 hover:border-primary rounded-xl p-2 transition-all hover:shadow-sm" src="@/assets/images/icons/app-marketplace/integrations/slack.svg" />
                        </vx-tooltip>
                        <vx-tooltip text="Import from Paylocity">
                          <img class="cursor-pointer w-12 h-12 border border-gray-200 hover:border-primary rounded-xl p-2 transition-all hover:shadow-sm" src="@/assets/images/icons/app-marketplace/integrations/paylocity.svg" />
                        </vx-tooltip>
                        <vx-tooltip text="Import from Hibob">
                          <img class="cursor-pointer w-12 h-12 border border-gray-200 hover:border-primary rounded-xl p-2 transition-all hover:shadow-sm" src="@/assets/images/icons/app-marketplace/integrations/hibob.svg" />
                        </vx-tooltip>
                        <vx-tooltip text="Import from Personio">
                          <img class="cursor-pointer w-12 h-12 border border-gray-200 hover:border-primary rounded-xl p-2 transition-all hover:shadow-sm" src="@/assets/images/icons/app-marketplace/integrations/personio.svg" />
                        </vx-tooltip>
                      </div>
                    </div>
                    
                  </div>

                  <!-- Users Queue List -->
                  <div v-if="usersToInvite.length > 0" class="mt-6">
                    <hr class="mb-4 border-gray-200" />
                    <p class="text-sm font-bold text-gray-800 mb-4 uppercase tracking-wide m-0">Ready to invite ({{usersToInvite.length}})</p>
                    
                    <div class="flex items-center pl-2">
                      <div @click.stop v-for="(user, i) in usersToInvite.slice(0, 8)" :key="i" class="-ml-2">
                        <vx-tooltip class="capitalize" :text="`${user.firstName} ${user.lastName}`">
                          <vs-avatar @click="openRemoveUserPrompt(user, i)" class="w-10 h-10 z-10 border-2 border-white cursor-pointer shadow-sm hover:-translate-y-1 transition-transform"
                            v-if="user.profilePictureUrl"
                            :src="`${constants.s3Bucket}/editor/profile-pictures/${user.profilePictureUrl}`" />
                          <vs-avatar @click="openRemoveUserPrompt(user, i)" v-else size="40px" class="m-0 border-2 border-white cursor-pointer shadow-sm hover:-translate-y-1 transition-transform" :src="`https://hostedboringavatars.vercel.app/api/beam?name=${avatarNameGenerator(user.firstName || 'boringAvatar', user.lastName || 'boringAvatar')}`" />
                        </vx-tooltip>
                      </div>

                      <div class="-ml-2 z-10" @click.stop v-if="usersToInvite.length > 8">
                        <vs-dropdown vs-trigger-click :color="orgData.primaryThemeColor">
                          <vx-tooltip :text="`${usersToInvite.length - 8} others`">
                            <vs-avatar @click.native="stopRouting" size="40px" class="cursor-pointer border-2 border-white shadow-sm"
                              :text="`+${usersToInvite.length - 8}`" />
                          </vx-tooltip>

                          <vs-dropdown-menu>
                            <vs-input class="m-2" id="vs--input" :color="`${orgData.primaryThemeColor}`" icon-no-border
                              icon="search" icon-size="large" placeholder="Search User" v-model="searchValue"
                              v-on:input="searchUser()" style="width: auto" />
                            <vs-dropdown-item class="mt-0 cursor-pointer" v-for="(user, index) in searchedUserArray"
                              :key="index" @click="openRemoveUserPrompt(user, index)">
                              <vs-avatar v-if="user.profilePictureUrl" size="32px" class="-m-1 mr-2"
                                :src="constants.s3Bucket + '/editor/profile-pictures/' + user.profilePictureUrl" />
                              <vs-avatar v-else size="32px" class="-m-1 mr-2"
                                :src="`https://hostedboringavatars.vercel.app/api/beam?name=${avatarNameGenerator(user.firstName, user.lastName)}`" />
                              <p class="text-sm m-0">{{ user.firstName }} {{ user.lastName }}</p>
                            </vs-dropdown-item>
                          </vs-dropdown-menu>
                        </vs-dropdown>
                      </div>
                    </div>
                  </div>
                  
                  <p v-if="usersEmpty" class="mt-4 text-sm font-medium text-red-500 m-0">
                    Invite teammates to continue
                  </p>

                  <!-- Footer Actions -->
                  <div class="flex justify-end gap-3 mt-8">
                    <vs-button type="border" color="dark" class="rounded-lg font-medium" @click="inviteUserModal = false">Cancel</vs-button>
                    <vs-button class="rounded-lg font-medium" @click="addToBoard" :disabled="usersToInvite.length === 0">Send Invites</vs-button>
                  </div>

                </div>
              </vs-popup>
              <!-- //invite user modal -->
            </div>
          </div>
        </div>
        <div v-if="fetchingBoardUsers" class="w-full h-full">
          <kanban-skeleton v-if="currentBoard.boardView === 'kanban'" />
          <loading v-else />
        </div>
        <div v-else-if="currentBoardUsers.length || searchedBoardUsers" tabindex="-1">
          <!-- Tabular -->
          <div v-if="boardView === 'tabular'">
            <tabular @editBoardUser="updateUserPopup" @resendBoardInvitationLink="resendBoardInvitationLink"
              @deactivateBoardUser="deactivateBoardUser" :isAlexInstalled="isAlexInstalled || false" />
          </div>

          <!-- Kanban -->
          <div v-else-if="boardView === 'kanban'">
            <kanban :isAlexInstalled="isAlexInstalled || false" @assignCoach="assignCoachPopup" />
          </div>

          <!-- Grid -->
          <div v-else>
            <grid @editBoardUser="updateUserPopup" @deactivateBoardUser="deactivateBoardUser"
              @resendBoardInvitationLink="resendBoardInvitationLink" :isAlexInstalled="isAlexInstalled || false" />
          </div>
        </div>
        <div v-else class="items-center">
          <img class="mb-3" src="@/assets/images/boards/start-onboarding.jpg" alt="Start On-Boarding" width="100%"
            style="opacity: 0.4; max-width: 500px" /><br />
          <vs-button class="invite-user-btn" @click.stop="activeInviteUserPrompt = true">Invite your first
            user</vs-button>
        </div>
      </div>
      <div v-else class="items-center">
        <processing-radial-chart :xlsxBoardUserInviteProgress="xlsxBoardUserInviteProgress" />
      </div>

      <!-- Board Deactivation Prompt -->
      <vs-prompt color="danger" class="deactivate-board-prompt" :title="`Confirm Board Deactivation`"
        @cancel="resetForm" @accept="deactivateBoard" @close="resetForm" accept-text="Deactivate"
        :is-valid="isDeactivationConfirmed" :active.sync="deactivationConfirmPrompt">
        <div class="mb-4">
          <h5>You are about to deactivate this board.</h5>
          <br />
          <p>After a board is deactivated, it <b>cannot be recovered</b>.</p>
          <br />
          <p>
            Deactivating this board will <b>immediately disable</b> all the apps
            for all the users on this board.
          </p>
          <br />
          <p class="mb-2">Please type the following to confirm:</p>
          <i v-if="currentBoard" style="background: lightgray; padding: 5px; border-radius: 5px">{{ currentBoard.title
          }}</i><br />
        </div>
        <vs-input class="w-full" name="Deactivate Board" data-vv-validate-on="blur" v-validate="'required'"
          v-model="deactivationText" />
      </vs-prompt>

      <parse-resume @closeResumePopup="closeResumePopup" :parseResumePopup="parseResumePopup"
        :userInvited="userInvited" />

      <vs-popup class="board-type-modal" :active.sync="publishBoardModal">
        <div class="w-full flex">
          <div class="">
            <div class="sticky top-0">
              <div class="flex items-center justify-center rounded-lg" :style="{
                background: 'linear-gradient(to bottom, #fff, #fce9ba)',
              }">
                <img src="@/assets/images/icons/golden-planet.svg" alt="Publish" />
              </div>
              <h2 class="px-8 pb-2 pt-6 bg-white">Publish as a</h2>
            </div>

            <div class="bg-white">
              <div class="px-8 pb-8 -mt-4">
                <div v-for="boardType in publishBoardTypes" :key="boardType.id"
                  class="bg-white p-4 rounded-lg mt-6 shadow-md border-white border-2 border-solid hover:border-primary"
                  @click="publishBoardWithStatus(boardType)">
                  <h3>{{ boardType.title }}</h3>
                  <p class="mt-4">
                    {{ boardType.description }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vs-popup>
      <!-- Remove relationship popup  -->
      <vs-prompt title="" @close="removeUserPrompt = false" :active="removeUserPrompt" buttons-hidden>
        <vs-col class="pb-4">
          <vs-row class="items-center justify-between mt-2 rounded-lg border-user px-4 py-2">
            <vs-row class="w-auto items-center">
              <div>
                <vs-avatar v-if="selectedUser.profilePictureUrl" size="45px" class="-m-1 mr-2" :src="constants.s3Bucket +
                  '/editor/profile-pictures/' +
                  selectedUser.profilePictureUrl
                  " />
                <vs-avatar v-else size="45px" class="-m-1 mr-2" :src="`https://hostedboringavatars.vercel.app/api/beam?name=${avatarNameGenerator(
                  selectedUser.firstName || 'boringAvatar',
                  selectedUser.lastName || 'boringAvatar'
                )}`" />
              </div>
              <div class="text-left">
                <div class="text-lg font-semibold text-black">
                  {{ selectedUser.firstName }}
                  {{ selectedUser.lastName }}
                </div>
                <div>
                  {{ selectedUser.email }}
                </div>
              </div>
            </vs-row>

            <img @click="removeUser" class="w-8 h-8 cursor-pointer" src="@/assets/images/icons/remove-dash.svg"
              alt="Remove Relationship" />
          </vs-row>
        </vs-col>
      </vs-prompt>
    </div>
  </div>
</template>

<script>
// import UserCard from "./components/UserCard.vue";
import allLanguages from "@/assets/data/all-languages.js";
import allCountries from "@/assets/data/country-codes.js";
import vSelect from "vue-select";
import marketplaceList from "@/assets/data/marketplace-list.js";
import Grid from "./mode/grid/Main.vue";
import Kanban from "./mode/kanban/Main.vue";
import Tabular from "./mode/tabular/Main.vue";
import _ from "lodash";
import constants from "@/constants.js";
import Loading from "./components/Loading.vue";
import ProcessingRadialChart from "./components/ProcessingRadialChart.vue";
import KanbanSkeleton from "./mode/kanban/components/Kanban.skeleton.vue";
import resumeTemplate from "../../../../assets/data/resume-template";
import coachConfigs from "@/assets/data/coach-configs.js";
import ParseResume from "./components/ParseResume.vue";

export default {
  data() {
    return {
      activeInviteTab: 'manual',
      usersToInvite: [],
      user: {},
      userErrors: {},
      constants,
      searchedUserArray: [],
      searchValue: "",
      removeUserPrompt: false,
      selectedUser: {},
      usersEmpty: null,
      activeInviteUserPrompt: false,
      activeUpdateUserPrompt: false,
      activeConnectWithCommServerPrompt: false,
      localData: {},
      languageOptions: allLanguages,
      countryOptions: allCountries,
      performanceOptions: [
        { key: 0, label: "Limited" },
        { key: 1, label: "Medium" },
        { key: 2, label: "High" },
      ],
      potentialOptions: [
        { key: 0, label: "Limited" },
        { key: 1, label: "Medium" },
        { key: 2, label: "High" },
      ],
      levelOptions: [
        { key: 0, label: "Player" },
        { key: 1, label: "Mentor" },
        { key: 2, label: "Leader" },
      ],
      userAlreadyExists: false,
      userAlreadyExistsInOtherBoard: false,
      duplicateBoardUser: false,
      marketplaceList,
      deactivationConfirmPrompt: false,
      deactivationText: null,
      isUpdateUserDetails: false,
      processingMode: false,
      xlsxBoardUserInviteProgress: {},
      processingModeInterval: "",
      boardChannelSubAdmins: [],
      boardInformation: false,
      availableCredits: 0,
      boardPricingData: {},
      resumeTemplate,
      assignCoachConfirmPrompt: false,
      assignedTraineeId: "",
      coachSelected: "",
      coachConfigs,
      allCoaches: [],
      coachOptions: [
        {
          key: "trainee",
          label: "Trainee",
        },
        {
          key: "coach",
          label: "Mentor",
        },
      ],
      userFoundInHibob: false,
      parseResumePopup: false,
      userInvited: false,
      isLinkCopied: false,
      isLanguagePresent: false,
      userEmails: [],
      boardOptions: [
        {
          id: null,
          label: "Select Board",
        },
      ],
      inviteUserModal: false,
      publishBoardModal: false,
      publishBoardTypes: [
        // {
        //   id: "public",
        //   title: "Public Journey",
        //   description:
        //     "Eleifend pharetra elit et suscipit. Nunc ornare ac ante eget lacinia. sed lacus vitae urna volutpat semper.",
        // },
        {
          id: "private",
          title: "Private Board",
          description:
            "Closed board accessible to only the users invited to this board.",
        },
        // {
        //   id: "quest",
        //   title: "Quest Journey",
        //   description:
        //     "Eleifend pharetra elit et suscipit. Nunc ornare ac ante eget lacinia. sed lacus vitae urna volutpat semper.",
        // },
        // {
        //   id: "",
        //   title: "Custom Journey",
        //   description:
        //     "Eleifend pharetra elit et suscipit. Nunc ornare ac ante eget lacinia. sed lacus vitae urna volutpat semper.",
        // },
        {
          id: "",
          title: "Coming Soon",
          description:
            "More boards types are coming soon. Look out for them down the road :)",
        },
      ],
      boardSelected: {
        id: null,
        label: "Select Board",
      },
    };
  },
  components: {
    vSelect,
    Grid,
    Kanban,
    Tabular,
    Loading,
    ProcessingRadialChart,
    KanbanSkeleton,
    ParseResume,
  },
  computed: {
    userData() {
      return this.$store.state.users.data;
    },
    currentBoardUsers() {
      return this.$store.state.boards.currentBoardUsers;
    },
    searchedBoardUsers() {
      return this.$store.state.boards.searchedBoardUsers;
    },
    orgData() {
      return this.$store.state.organization.orgData;
    },
    inviteFormDisabled() {
      if (this.userAlreadyExists && !this.isUpdateUserDetails) {
        return true;
      }
      return false;
    },
    validForm() {
      let validEmail = this.localData.email;
      let validFirstName = this.localData.firstName;
      let validLastName = this.localData.lastName;
      let validPrimaryLanguage = this.localData.primaryLanguage;
      let validCurrentLocation = this.localData.currentLocation;
      // let validDateOfBirth = this.localData.dob;
      // let validRoleTitle = this.localData.roleTitle;
      // let validLevel = this.localData.level;
      // let validNumOfDirRep = this.localData.numberOfDirectReports;
      // let validDepartment = this.localData.department;
      // let validPerformance = this.localData.performance;
      // let validPotential = this.localData.potential;

      // For self user
      if (this.isNewOrgBoard && this.userData && this.userData.email) {
        validEmail = this.localData.email
          ? this.localData.email
          : this.userData.email;
        validFirstName = this.localData.firstName
          ? this.localData.firstName
          : this.userData.firstName;
        validLastName = this.localData.lastName
          ? this.localData.lastName
          : this.userData.lastName;
      }

      if (this.isAlexInstalled) {
        if (
          // Alex is installed
          this.$validator.errors.items.length ||
          !validEmail ||
          this.userAlreadyExists ||
          !validFirstName ||
          !validLastName ||
          !validPrimaryLanguage ||
          !validCurrentLocation
        ) {
          return false;
        }
      } else {
        if (
          // Alex is not installed
          this.$validator.errors.items.length ||
          !validEmail ||
          this.userAlreadyExists ||
          !validFirstName ||
          !validLastName
        ) {
          return false;
        }
      }

      // if form is valid
      return true;
    },
    currentBoard() {
      return this.$store.state.boards.currentBoard;
    },
    avatarNameGenerator() {
      return this.$store.state.users.avatarNameGenerator;
    },
    isDeactivationConfirmed() {
      if (
        this.currentBoard &&
        this.deactivationText === `${this.currentBoard.title}`
      )
        return true;
      else return false;
    },
    isNewOrgBoard() {
      if (Boolean(this.$route.query["neworgboard"]) === true) {
        return true;
      }
      return false;
    },
    installedApps() {
      if (this.currentBoard) return this.currentBoard.installedApps;
      return [];
    },
    isAlexInstalled() {
      if (this.installedApps)
        return (
          this.installedApps.includes("alex") ||
          this.installedApps.includes("journey")
        );
      return false;
    },
    isJourneyInstalled() {
      if (this.installedApps) return this.installedApps.includes("journey");
      return false;
    },
    isCoachInstalled() {
      if (this.installedApps) return this.installedApps.includes("coach");
      return false;
    },
    boardView() {
      if (this.currentBoard) return this.currentBoard.boardView;
      else return "grid";
    },
    fetchingBoardUsers: {
      get() {
        return this.$store.state.boards.fetchingBoardUsers;
      },
      set() {
        this.$store.commit("boards/SET_FETCHING_BOARD_USERS", true);
      },
    },
    isAssignCoachValid() {
      if (
        this.assignedTraineeId &&
        this.coachSelected &&
        this.assignedTraineeId
      )
        return true;
      return false;
    },
    inviteUserJsonData() {
      return this.$store.state.parser.userJsonResponse;
    },
    organizationConfiguration() {
      return this.$store.state.organization.organizationConfiguration;
    },
    allOrgBoards() {
      return this.$store.state.boards.allBoards;
    },
  },
  watch: {
    currentBoard(newVal) {
      if (newVal) {
        this.$store
          .dispatch("boards/fetchAllUsersInBoardV2", newVal._id)
          .catch((err) => {
            throw err;
          });

        // Set Route Title
        this.$store.commit(
          "organization/SET_CUSTOM_ROUTE_TITLE",
          this.currentBoard.title
        );

        this.$store
          .dispatch("payments/fetchCredits", {
            boardId: newVal._id,
          })
          .then((res) => {
            this.availableCredits = res.data.availableCredits;
          });

        const payload = {
          appIds: newVal.installedApps,
          numberOfUsers: newVal.numberOfUsers,
          numberOfMonths: newVal.numberOfMonths,
          timePeriodMovement: "ceil",
        };

        this.$store
          .dispatch("payments/fetchBoardPrice", payload)
          .then((res) => {
            this.boardPricingData.totalPricePerUser = (
              Number(res.data.totalPrice) / Number(newVal.numberOfUsers)
            ).toFixed(2);
          });

        // Runs every 3 seconds, to check if any xlsx is under processing
        // clearInterval(this.processingModeInterval);
        // this.processingModeInterval = setInterval(async () => {
        //   await this.fetchBoardUserProcessingStatus(newVal._id);
        // }, 1000);

        // Fetch Coaches
        if (
          this.currentBoard.installedApps &&
          this.currentBoard.installedApps.includes("coach")
        ) {
          this.$store.dispatch(
            "boards/fetchBoardUsersCoach",
            this.currentBoard._id
          );
        }
      }
    },
    isNewOrgBoard(newVal) {
      if (newVal === true) {
        this.localData.email = this.userData.email;
        this.userExists();
        this.activeInviteUserPrompt = true;
      }
    },
    userData(newVal) {
      if (this.isNewOrgBoard === true) {
        this.localData.email = newVal.email;
        this.localData.firstName = newVal.firstName;
        this.localData.lastName = newVal.lastName;
        this.localData.gender = newVal.gender;
        // this.localData.dob = this.userData.dob ? this.userData.dob.split('T')[0] : undefined;
        this.userExists();
      }
    },
    $route() {
      this.fetchBoard();
    },
    processingMode(newVal) {
      if (newVal) {
        // window.location.reload();
      }
    },
    currentBoardUsers() {
      this.getAllCoaches();
      this.$forceUpdate();
    },
    inviteUserJsonData: {
      handler(val) {
        if (val && Object.keys(val).length) {
          // console.log(val);
          this.localData.email = val.personal_details.contactDetails.email;
          this.localData.firstName = val.personal_details.name.firstName;
          this.localData.lastName = val.personal_details.name.lastName;
          this.userExists();
          this.activeInviteUserPrompt = true;
        }
      },
      deep: true,
    },
    allOrgBoards: {
      immediate: true,
      dep: true,
      handler(newVal) {
        if (newVal.length > 0) {
          for (let i = 0; i < newVal.length; i++) {
            if (this.currentBoard._id !== newVal[i]._id) {
              this.boardOptions.push({
                id: newVal[i]._id,
                label: newVal[i].title,
              });
            }
          }
        } else {
          this.$store.dispatch("boards/fetchAllBoards", this.orgData._id);
        }
      },
    },
    usersToInvite: {
      deep: true,
      immediate: true,
      handler(newVal) {
        this.usersEmpty =
          newVal.length > 0 && this.usersEmpty ? false : this.usersEmpty;
      },
    },
    boardSelected: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.id) {
          this.addUserFromBoard(newVal.id);
        }
      },
    },
  },
  methods: {
    addToBoard() {
      if (this.usersToInvite.length !== 0) {
        for (let i = 0; i < this.usersToInvite.length; i++) {
          let { email, firstName, lastName } = this.usersToInvite[i];
          const payload = {
            boardId: this.$route.params.boardId,
            email: email,
            firstName: firstName,
            lastName: lastName,
          };
          this.$store
            .dispatch("boards/addUserToBoard", payload)
            .then((res) => { })
            .catch((err) => { });
        }
        this.$vs.notify({
          title: "In Progress",
          text: "User On-Boarding is running in background",
          iconPack: "feather",
          icon: "icon-check-circle",
          color: "success",
          fixed: false,
        });
        // setTimeout(() => {
        //   window.location.reload();
        // }, 150);
      } else {
        this.usersEmpty = true;
      }
    },
    autoFetchUser() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      let isEmailVald = emailRegex.test(this.user.email);
      if (isEmailVald) {
        this.$store
          .dispatch("boards/fetchUserByEmail", {
            email: this.user.email,
            installedApps: [],
            organizationId: this.orgData._id,
          })
          .then((userRes) => {
            if (
              userRes &&
              userRes.data &&
              userRes.data.data &&
              userRes.data.data[0]
            ) {
              let { email, firstName, lastName, profilePictureUrl } =
                userRes.data.data[0];
              this.user = {
                email: email,
                firstName: firstName,
                lastName: lastName,
                profilePictureUrl: profilePictureUrl,
              };
            }
          });
      }
    },
    addUsersForInvite() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      this.userErrors = {
        firstName: !this.user.firstName,
        lastName: !this.user.lastName,
        email: !this.user.email,
        isEmailValid: this.user.email
          ? !emailRegex.test(this.user.email)
          : false,
      };

      const hasErrors = Object.values(this.userErrors).some((error) => error);
      if (!hasErrors) {
        this.usersToInvite.push(this.user);
        this.searchedUserArray = this.usersToInvite;
        this.userErrors = {};
        this.user = {};
      }
    },
    searchUser() {
      if (this.searchValue) {
        this.searchedUserArray = this.usersToInvite.filter((user) => {
          if (user.firstName && user.lastName) {
            return (
              user.firstName
                .toLowerCase()
                .includes(this.searchValue.toLowerCase()) ||
              user.lastName
                .toLowerCase()
                .includes(this.searchValue.toLowerCase())
            );
          } else if (user.firstName) {
            return user.firstName
              .toLowerCase()
              .includes(this.searchValue.toLowerCase());
          } else if (user.lastName) {
            return user.lastName
              .toLowerCase()
              .includes(this.searchValue.toLowerCase());
          }
        });
        return;
      } else {
        return (this.searchedUserArray = this.usersToInvite);
      }
    },
    openRemoveUserPrompt(user, index) {
      this.selectedUser = user;
      this.selectedUser.activeIndex = index;
      this.removeUserPrompt = true;
    },
    removeUser() {
      this.usersToInvite.splice(this.selectedUser.activeIndex, 1);
      this.removeUserPrompt = false;
      this.selectedUser = {};
    },
    isLanguageTyped(input) {
      this.isLanguagePresent = input.data ? true : false;
    },
    getAppDataById(id) {
      const appIndex = this.marketplaceList.findIndex((app) => {
        return app.id === id;
      });
      if (appIndex !== -1) return this.marketplaceList[appIndex];
      else return appIndex;
    },
    userExists() {
      // refresh local data
      let email = this.localData.email;
      this.localData = {};
      this.localData.email = email;
      this.userAlreadyExistsInOtherBoard = false;
      this.userFoundInHibob = false;

      if (this.localData.email && this.isValidEmail(this.localData.email)) {
        if (
          !this.isUpdateUserDetails &&
          this.currentBoard._id &&
          this.localData.email
        ) {
          // Check in same board
          this.$store
            .dispatch("boards/fetchBoardUserByEmail", {
              email: this.localData.email,
              boardId: this.currentBoard._id,
            })
            .then((res) => {
              if (res && res.data.total > 0) {
                this.userAlreadyExists = true;
              } else {
                this.userAlreadyExists = false;
              }
            });
        }

        if (!this.userAlreadyExists) {
          this.$store
            .dispatch("boards/fetchUserByEmail", {
              email: this.localData.email,
              installedApps: this.currentBoard.installedApps,
              organizationId: this.orgData._id,
            })
            .then((userRes) => {
              if (userRes.data && userRes.data.total === 1) {
                this.userFoundInHibob = userRes.data.userFoundInHibob
                  ? true
                  : false;

                // auto-populate user data
                userRes = userRes.data.data[0];
                // this.localData.email = userRes.email;
                this.localData.firstName = userRes.firstName;
                this.localData.lastName = userRes.lastName;
                this.localData.gender = userRes.gender;
                this.localData.currentLocation = userRes.currentLocation;
                // this.localData.dob = userRes.dob ? userRes.dob.split('T')[0]:null;
                this.localData = JSON.parse(JSON.stringify(this.localData));

                this.$store
                  .dispatch("boards/fetchBoardUserConfig", {
                    userId: userRes._id,
                  })
                  .then((boardUserConfig) => {
                    if (
                      boardUserConfig.data &&
                      boardUserConfig.data.total === 1
                    ) {
                      boardUserConfig = boardUserConfig.data.data[0];

                      this.userAlreadyExistsInOtherBoard = true;
                      this.duplicateBoardUser = true;

                      // Auto-populate data
                      this.localData = {
                        ...this.localData,
                        ...boardUserConfig,
                      };
                      this.localData = JSON.parse(
                        JSON.stringify(this.localData)
                      );
                    } else {
                      this.userAlreadyExistsInOtherBoard = false;
                    }
                  });
              }
            });
        }
      }
    },
    resetForm() {
      this.localData = {};
      this.deactivationText = null;
      if (this.isNewOrgBoard === true) {
        this.$router.replace({ name: "org-boards-view" });
      }
      this.userAlreadyExists = false;
      this.userAlreadyExistsInOtherBoard = false;
      this.isUpdateUser = false;
      this.boardChannelSubAdmins = [];
      this.assignedTraineeId = "";
      this.coachSelected = {};
      this.userFoundInHibob = false;
    },
    cancelForm() {
      this.activeInviteUserPrompt = false;
      this.activeUpdateUserPrompt = false;
      this.activeConnectWithCommServerPrompt = false;
      this.resetForm();
    },
    addUserToBoard() {
      let userType;
      if (this.localData.userType === "mentor") {
        userType = "coach";
      } else if (this.localData.userType === "player") {
        userType = "trainee";
      } else {
        userType = this.localData.userType;
      }

      const payload = {
        boardId: this.currentBoard._id,
        email: this.localData.email,
        firstName: this.localData.firstName,
        lastName: this.localData.lastName,
        gender: this.localData.gender,
        primaryLanguage: this.localData.primaryLanguage,
        currentLocation: this.localData.currentLocation,
        roleTitle: this.localData.roleTitle,
        level: this.localData.level,
        department: this.localData.department,
        numberOfDirectReports: this.localData.numberOfDirectReports,
        performance: this.localData.performance,
        potential: this.localData.potential,
        userType: userType,
      };

      this.$store
        .dispatch("boards/addUserToBoard", payload)
        .then((res) => {
          this.$vs.notify({
            title: "In Progress",
            text: "User On-Boarding is running in background",
            iconPack: "feather",
            icon: "icon-check-circle",
            color: "success",
            fixed: false,
          });
          this.resetForm();
          this.cancelForm();
          this.$vs.loading.close();
        })
        .catch((err) => {
          this.$vs.notify({
            title: "Failed to send Board invitation",
            text: "Failed to update user details",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            fixed: false,
          });
          this.$vs.loading.close();
          throw err;
        });
    },
    updateUserPopup(email) {
      this.isUpdateUserDetails = true;
      this.localData.email = email;
      this.userExists();
      this.activeUpdateUserPrompt = true;
    },
    updateUser() {
      this.$vs.loading();

      this.localData.password = Math.random().toString(36).substring(15);

      const userObj = {
        email: this.localData.email,
        password: this.localData.password,
        firstName: this.localData.firstName,
        lastName: this.localData.lastName,
        dob: this.localData.dob,
        gender: this.localData.gender,
      };

      const boardUserObj = {
        email: this.localData.email,
        boardId: this.currentBoard._id,
        boardTitle: this.currentBoard.title,
        organizationId: this.orgData._id,
        primaryLanguage: this.localData.primaryLanguage,
        currentLocation: this.localData.currentLocation,
        roleTitle: this.localData.roleTitle,
        level: this.localData.level,
        department: this.localData.department,
        numberOfDirectReports: this.localData.numberOfDirectReports,
        performance: this.localData.performance,
        potential: this.localData.potential,
        status: false,
      };

      this.$store
        .dispatch("boards/updateUserOnBoard", {
          userObj,
          boardUserObj,
          installedApps: this.currentBoard.installedApps,
          createDuplicate: this.duplicateBoardUser,
          orgSlug: this.orgData.slug,
        })
        .then((res) => {
          this.$vs.notify({
            title: "User Details Updates",
            text: "User details have been updated",
            iconPack: "feather",
            icon: "icon-check-circle",
            color: "success",
            fixed: false,
          });

          this.resetForm();
          this.cancelForm();

          this.$vs.loading.close();
        })
        .catch((err) => {
          this.$vs.notify({
            title: "Failed to send Board invitation",
            text: "Failed to update user details",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            fixed: false,
          });

          this.$vs.loading.close();

          throw err;
        });
    },
    monthDiff(d1, d2) {
      let months;
      months = (d2.getFullYear() - d1.getFullYear()) * 12;
      months -= d1.getMonth();
      months += d2.getMonth();
      return months <= 0 ? 0 : months;
    },
    deactivateBoard() {
      this.$vs.loading();

      this.$store
        .dispatch("boards/deactivateBoard", {
          boardId: this.currentBoard._id,
          boardTitle: this.currentBoard.title,
          organizationId: this.orgData._id,
        })
        .then((res) => {
          if (this.availableCredits) {
            const payload = {
              appIds: this.currentBoard.installedApps,
              numberOfUsers: Number(this.currentBoard.numberOfUsers),
              numberOfMonths: Number(
                this.currentBoard.numberOfMonths
                  ? this.currentBoard.numberOfMonths
                  : 1
              ),
              timePeriodMovement: "ceil",
              excludeOneTimeApps: true,
            };

            this.$store
              .dispatch("payments/fetchBoardPrice", payload)
              .then((res) => {
                const pricePerUser =
                  Number(res.data.netPrice) / Number(payload.numberOfUsers);
                const creditsToFundAmount = (
                  pricePerUser * this.availableCredits
                ).toFixed(2);

                /////////////////////////////////////////
                // create transaction for added user
                /////////////////////////////////////////
                this.$store.dispatch("payments/createTransaction", {
                  organizationId: this.orgData._id,
                  userId: this.userData._id,
                  amount: creditsToFundAmount,
                  boardId: this.currentBoard._id,

                  currency: "eur",
                  fundType: "UNLOCKED",
                  remark: `${this.currentBoard.title} Board Refund`,
                  deductFund: false,
                  addFund: creditsToFundAmount > 0 ? true : false,
                  details: {
                    creditsRefunded: this.availableCredits,
                    totalPricePerUser: pricePerUser,
                  },
                  transactionType: "BOARD_TRANSACTION",
                });

                ///////////////////////////////////
                // add credits to board
                ///////////////////////////////////
                this.$store.dispatch("payments/removeCredits", {
                  organizationId: this.orgData._id,
                  userId: this.userData._id,
                  boardId: this.currentBoard._id,
                  credits: this.availableCredits,
                });

                setTimeout(() => {
                  window.location.href = `/organization/${this.orgData._id}/dashboard`;
                }, 2000);
              });
          } else {
            window.location.href = `/organization/${this.orgData._id}/dashboard`;
          }
        })
        .catch((err) => {
          throw err;
        });
    },
    fetchBoard() {
      const boardId = this.$route.params.boardId;
      this.$vs.loading();
      this.$store
        .dispatch("boards/fetchBoardById", boardId)
        .then(() => {
          this.$vs.loading.close();
        })
        .catch((err) => {
          throw err;
        });
    },
    initiateKanbanData(boardUserObj) {
      // Depreceate
      // this.$store.dispatch('kanban/fetchKanbanDatabyBoardId', { 'boardId': this.currentBoard._id }).then(res => {
      //     if(res && res.total === 1 && res.data && res.data[0].cols && res.data[0].cols[0]) {
      //       let cud = JSON.parse(JSON.stringify(res.data[0].cols));
      //       cud[0].colUsersData.unshift({
      //           boardUserId: boardUserObj._id,
      //           boardUserConfigId: boardUserObj.boardUserConfigId
      //       });

      //       this.$store.dispatch('kanban/updateKanban', { 'kanbanId': res.data[0]._id, 'cols': cud })
      //       .catch(err => {
      //           throw err;
      //       });
      //     }
      // }).catch(err => {
      //     throw err;
      // });

      this.$store.dispatch("kanban/addUserToInitialPhaseV2", {
        boardId: boardUserObj.boardId,
        userId: boardUserObj.userId,
        boardUserId: boardUserObj._id,
        boardUserConfigId: boardUserObj.boardUserConfigId,
      });
    },
    setBoardView(currentBoardView, boardView) {
      if (currentBoardView === "grid" && boardView === "grid") {
        boardView = "tabular";
      } else if (currentBoardView === "grid" && boardView === "tabular") {
        boardView = "tabular";
      } else if (currentBoardView === "tabular" && boardView === "grid") {
        boardView = "grid";
      } else if (currentBoardView === "tabular" && boardView === "tabular") {
        boardView = "grid";
      } else if (currentBoardView === "kanban" && boardView === "grid") {
        boardView = "grid";
      } else if (currentBoardView === "kanban" && boardView === "tabular") {
        boardView = "tabular";
      } else {
        boardView = "kanban";
      }

      this.$store
        .dispatch("boards/updateBoardView", {
          boardId: this.currentBoard._id,
          boardView,
        })
        .catch((err) => {
          throw err;
        });
    },
    resendBoardInvitationLink(email) {
      const boardUserData = _.find(this.currentBoardUsers, (cbu) => {
        return cbu.userData.email === email;
      });

      const payload = {
        userId: boardUserData.userData._id,
        email: boardUserData.userData.email,
        firstName: boardUserData.userData.firstName,
        lastName: boardUserData.userData.lastName,
        boardId: boardUserData.boardId,
        boardTitle: this.currentBoard.title,
        // organizationId: "607aa2cce7a4360958e1538b",
        organizationId: this.currentBoard.organizationId,
        mailType: "board-invitation",
      };

      this.$store
        .dispatch("boards/resendBoardInvitationLink", payload)
        .then((res) => {
          this.$vs.notify({
            title: "Board invitation resent successfully",
            text: "Board invitation resent successfully",
            iconPack: "feather",
            icon: "icon-check-circle",
            color: "success",
            fixed: false,
          });
        })
        .catch((err) => {
          this.$vs.notify({
            title: "Failed to send Board invitation",
            text: "Failed to send Board invitation",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            fixed: false,
          });
          throw err;
        });
    },
    deactivateBoardUser(boardUserObj) {
      this.$store
        .dispatch("boards/deactivateBoardUser", {
          boardUserId: boardUserObj._id,
          boardUserObj,
        })
        .then((res1) => {
          const payload = {
            appIds: this.currentBoard.installedApps,
            numberOfUsers: Number(this.currentBoard.numberOfUsers),
            numberOfMonths: Number(
              this.currentBoard.numberOfMonths
                ? this.currentBoard.numberOfMonths
                : 1
            ),
            timePeriodMovement: "ceil",
            excludeOneTimeApps: true,
          };

          this.$store
            .dispatch("payments/fetchBoardPrice", payload)
            .then((res) => {
              const pricePerUserPerMonth =
                Number(res.data.netPrice) /
                Number(payload.numberOfUsers) /
                Number(payload.numberOfMonths);
              const numberOfMonthsUsed = this.monthDiff(
                new Date(this.currentBoard.createdAt),
                new Date()
              );
              const numberOfMonthsLeft =
                Number(payload.numberOfMonths) - numberOfMonthsUsed;
              const creditsToFundAmount =
                (pricePerUserPerMonth * 1).toFixed(2) *
                (numberOfMonthsLeft - 1);

              /////////////////////////////////////////
              // create transaction for removed user
              /////////////////////////////////////////
              this.$store.dispatch("payments/createTransaction", {
                organizationId: this.orgData._id,
                userId: this.userData._id,
                amount: creditsToFundAmount,
                boardId: boardUserObj.boardId,
                currency: "eur",
                fundType: "REFUND",
                remark: `${boardUserObj.userData.firstName} ${boardUserObj.userData.lastName} removed from ${this.currentBoard.title}`,
                deductFund: false,
                addFund: true,
                transactionType: "USER_TRANSACTION",
                details: {
                  ...payload,
                  pricePerUserPerMonth,
                  numberOfMonthsUsed,
                  numberOfMonthsLeft,
                },
              });

              ///////////////////////////////////
              // add credits to board
              ///////////////////////////////////
              this.$store.dispatch("payments/addCreditsToBoard", {
                organizationId: this.orgData._id,
                userId: this.userData._id,
                boardId: this.currentBoard._id,
                credits: 1,
              });

              this.$vs.notify({
                title: "User Removed",
                text: "User removed from board",
                iconPack: "feather",
                icon: "icon-check-circle",
                color: "success",
                fixed: false,
              });
            });
        })
        .catch((err) => {
          this.$vs.notify({
            title: "User cannot be removed",
            text: "Failed to remove user from board",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            fixed: false,
          });
        });
    },
    copyBoardInviteLink() {
      const boardInviteLink = `${constants.url}/board/invite/${this.currentBoard.slug}`;
      navigator.clipboard.writeText(boardInviteLink);
      navigator.clipboard.writeText(boardInviteLink).then(() => {
        this.isLinkCopied = true;

        this.$vs.notify({
          text: "Board invite link copied successfully !",
          iconPack: "feather",
          icon: "icon-check-circle",
          color: "success",
          fixed: false,
        });
      });

      this.$store.dispatch("organization/logOrganizationActivity", {
        organizationId: this.currentBoard.organizationId,
        logObj: {
          logText: `Copied ${this.currentBoard.title} board invite link`,
          status: "active",
          boardId: this.currentBoard._id,
          userId: this.userData._id,
        },
      });
    },
    async uploadInviteeExcel(e) {
      const boardId = this.currentBoard._id;
      const inviteeFormData = new FormData();
      inviteeFormData.append("inviteeExcel", e.target.files["0"]);
      inviteeFormData.append("boardId", boardId);
      this.$store.dispatch("boards/inviteFromExcel", {
        inviteeFormData,
        boardId,
      });

      // Runs every 3 seconds, to check if any xlsx is under processing
      // clearInterval(this.processingModeInterval);
      // this.processingModeInterval = setInterval(async () => {
      //   await this.fetchBoardUserProcessingStatus(boardId);
      // }, 1000);
    },
    async fetchBoardUserProcessingStatus(boardId) {
      const newBoardUsersProcessProgress = await this.$store.dispatch(
        "boards/fetchBoardUserProcessingStatus",
        { boardId }
      );
      if (newBoardUsersProcessProgress.total >= 1) {
        this.processingMode = true;
        this.xlsxBoardUserInviteProgress = newBoardUsersProcessProgress.data[0];
      } else {
        this.processingMode = false;
        clearInterval(this.processingModeInterval);
        if (!_.isEmpty(this.xlsxBoardUserInviteProgress)) {
          if (
            Number(this.xlsxBoardUserInviteProgress.processedUsers) ===
            Number(this.xlsxBoardUserInviteProgress.totalUsers) - 1
          ) {
            window.location.reload();
          }
        }
      }
    },
    syncBoardChannel() {
      if (_.isEmpty(this.orgData) || !this.currentBoard.rktChannelId) return;

      this.$vs.notify({
        title: "Board is currently being synced with Comm Server",
      });

      let members = [];

      if (!_.isEmpty(this.orgData.subAdmins)) {
        members = _.map(this.orgData.subAdmins, (subAdmin) => {
          return {
            email: subAdmin.email,
            userId: subAdmin.userData[0] ? subAdmin.userData[0]._id : "",
            name: subAdmin.userData[0]
              ? `${subAdmin.userData[0].firstName} ${subAdmin.userData[0].lastName}`
              : "",
            rktChannelId: this.currentBoard.rktChannelId,
          };
        });
      }

      if (!_.isEmpty(this.orgData.admin)) {
        members.push({
          email: this.orgData.admin.email,
          userId: this.orgData.admin._id,
          name: `${this.orgData.admin.firstName} ${this.orgData.admin.lastName}`,
          rktChannelId: this.currentBoard.rktChannelId,
        });
      }

      this.$store
        .dispatch("boards/syncBoardChannel", { members })
        .catch((err) => {
          throw err;
        });
    },
    connectWithCommServer() {
      if (_.isEmpty(this.orgData) || this.currentBoard.rktChannelId) return;

      this.$vs.loading();

      const boardObj = {
        title: this.currentBoard.title,
        boardId: this.currentBoard._id,
        orgSlug: this.orgData.slug,
        organizationId: this.orgData._id,
      };

      this.$store
        .dispatch("boards/connectWithCommServer", { boardObj })
        .then((res) => {
          this.$vs.loading.close();

          this.$vs.notify({
            title: "This board is now connected to Comm Server",
          });

          // Add all board channel admins
          this.syncBoardChannel();
        })
        .catch((err) => {
          this.$vs.loading.close();
          throw err;
        });
    },
    assignCoachPopup(traineeId) {
      try {
        this.assignCoachConfirmPrompt = true;
        this.assignedTraineeId = traineeId;
      } catch (error) {
        console.error(error);
      }
    },
    assignCoach() {
      try {
        this.$vs.loading();

        this.$store
          .dispatch("boards/assignCoach", {
            gtbrddOrganizationId: this.orgData._id,
            traineeEmail: this.getUserDataById(this.assignedTraineeId).userData
              .email,
            traineeUserId: this.assignedTraineeId,
            traineeBoardUserId: this.getUserDataById(this.assignedTraineeId)
              ._id,
            coachEmail: this.coachSelected.key.email,
            coachUserId: this.coachSelected.key.userId,
            coachBoardUserId: this.coachSelected.key.boardUserId,
            boardId: this.currentBoard._id,
            traineePledged:
              this.getUserDataById(this.assignedTraineeId) &&
                this.getUserDataById(this.assignedTraineeId).userData &&
                this.getUserDataById(this.assignedTraineeId).userData
                  .revealTermsStatus
                ? true
                : false,
          })
          .then(() => {
            this.$vs.loading.close();
          })
          .catch(() => {
            this.$vs.loading.close();
          });
      } catch (error) {
        this.$vs.loading.close();
        console.error(error);
      }
    },
    getUserDataById(userId) {
      return this.currentBoardUsers.find((user) => {
        return userId == user.userId;
      });
    },
    getAllCoaches() {
      if (this.currentBoardUsers.length > 0) {
        this.allCoaches = this.currentBoardUsers
          .filter((user) => {
            if (
              user.boardUserConfigData &&
              user.boardUserConfigData.userType &&
              user.boardUserConfigData.userType.toLowerCase() === "coach"
            ) {
              return true;
            } else if (
              user.boardUserConfig &&
              user.boardUserConfig.userType &&
              user.boardUserConfig.userType.toLowerCase() === "coach"
            ) {
              return true;
            }
            return false;
          })
          .map((user) => {
            return {
              label: `${user.userData.firstName} ${user.userData.lastName}`,
              key: {
                boardUserId: user._id,
                userId: user.userData._id,
                email: user.userData.email,
              },
            };
          });
      }
    },
    isValidEmail(email) {
      return String(email)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    },
    parseResume() {
      this.parseResumePopup = true;
    },
    closeResumePopup(val) {
      this.parseResumePopup = val;
      this.userInvited = val;
    },
    publishBoardWithStatus(boardType) {
      if (boardType.id) {
        this.$store
          .dispatch("boards/updateBoardPrivacy", {
            boardId: this.currentBoard._id,
            privacy: boardType.id.toUpperCase(),
          })
          .then((res) => {
            if (res && res.data && res.data._id) {
              if (this.currentBoard.status === "draft") {
                this.$store
                  .dispatch("boards/updateBoard", {
                    boardObj: {
                      status: "active",
                      createBoardPaymentSession: false,
                      _boardId: this.currentBoard._id,
                    },
                    organizationId: this.orgData._id,
                  })
                  .then((res) => {
                    if (res && res.data && res.data._id) {
                      this.$vs.notify({
                        text: "Board published successfully",

                        iconPack: "feather",
                        icon: "icon-check-circle",
                        color: "success",
                        fixed: false,
                      });
                    }
                    console.log(res);
                  })
                  .catch((err) => {
                    throw err;
                  });
              } else {
                if (res && res.data && res.data._id) {
                  this.$vs.notify({
                    text: "Board published successfully",

                    iconPack: "feather",
                    icon: "icon-check-circle",
                    color: "success",
                    fixed: false,
                  });
                }
              }
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            return (this.publishBoardModal = false);
          });
      }
    },
    addUserFromBoard(boardId) {
      this.$store
        .dispatch("boards/fetchUsersInBoard", boardId)
        .then((res) => {
          if (res && res.data && res.data.data) {
            for (let i = 0; i < res.data.data.length; i++) {
              let user = {
                firstName: res.data.data[i].userData.firstName,
                lastName: res.data.data[i].userData.lastName,
                email: res.data.data[i].userData.email,
              };

              let isUserInCurrentBoard = this.currentBoardUsers.some(
                (boardUser) => boardUser.email === user.email
              );

              let isUserInUsersToInvite = this.usersToInvite.some(
                (invitedUser) => invitedUser.email === user.email
              );

              if (!isUserInCurrentBoard && !isUserInUsersToInvite) {
                this.usersToInvite.push(user);
              }
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    // Admin/Sub-admin can invite themselves
    if (this.isNewOrgBoard === true) {
      if (this.userData && this.userData.email) {
        // Check if board user config exists
        this.userExists();
        this.localData.email = this.userData.email;
        this.localData.firstName = this.userData.firstName;
        this.localData.lastName = this.userData.lastName;
        this.localData.gender = this.userData.gender;
        // this.localData.dob = this.userData.dob ? this.userData.dob.split('T')[0] : undefined;
      }
      this.activeInviteUserPrompt = true;
    }

    // Set Route Title
    this.$store.commit(
      "organization/SET_CUSTOM_ROUTE_TITLE",
      this.currentBoard.title
    );
  },
  created() {
    this.fetchingBoardUsers = true;

    if (this.currentBoard && this.currentBoard._id) {
      this.$store
        .dispatch("boards/fetchAllUsersInBoardV2", this.currentBoard._id)
        .catch((err) => {
          throw err;
        });

      this.$store
        .dispatch("payments/fetchCredits", {
          boardId: this.currentBoard._id,
        })
        .then((res) => {
          this.availableCredits = res.data.availableCredits;
        });

      const payload = {
        appIds: this.currentBoard.installedApps,
        numberOfUsers: this.currentBoard.numberOfUsers,
        numberOfMonths: this.currentBoard.numberOfMonths,
        timePeriodMovement: "ceil",
      };

      this.$store.dispatch("payments/fetchBoardPrice", payload).then((res) => {
        this.boardPricingData.totalPricePerUser = (
          Number(res.data.totalPrice) / Number(this.currentBoard.numberOfUsers)
        ).toFixed(2);
      });

      if (
        this.currentBoard.installedApps &&
        this.currentBoard.installedApps.includes("coach")
      ) {
        this.$store.dispatch(
          "boards/fetchBoardUsersCoach",
          this.currentBoard._id
        );
      }
    }

    // fetch board details
    this.fetchBoard();
  },
  beforeDestroy() {
    this.$store.commit("boards/CLEAR_CURRENT_BOARD");
    this.resetForm();
  },
};
</script>

<style lang="scss" scoped>
input {
  outline: none;
  border-radius: 10px;
  border: 2px solid #e8ebed;

  &:focus {
    outline: none;
    border: 2px solid #c4c5c7;
  }
}

.error {
  &-input {
    border: 2px solid #ff507a;
  }

  &-text {
    color: #ff507a;
  }
}
</style>

<style scoped>
.invite-user-btn {
  border-radius: 6px;
}

.invite-user-prompt>>>.vs-dialog {
  width: 900px;
  max-width: 900px;
  max-height: calc(100vh - 100px);
}

.invitee-form {
  /* overflow-y: auto; */
  max-height: calc(100vh - 250px);
}

.invitee-form .invitee-form-input>>>.vs-con-input .vs-input--input {
  background: #f4f6fb !important;
  /* Solitude */
  border: 1px solid #dfe3eb !important;
  box-sizing: border-box !important;
  border-radius: 6px !important;
}

.vs--searchable>>>.vs__dropdown-toggle {
  background: #f4f6fb !important;
  /* Solitude */
  border: 1px solid #dfe3eb !important;
  border-radius: 6px !important;
  padding: 0.5rem !important;
}

.board-type-modal>>>.vs-popup {
  width: 400px;
}

.board-type-modal>>>.vs-popup--header {
  display: none;
}

.board-type-modal>>>.vs-popup--content {
  padding: 0;
}

.installed-apps {
  display: flex;
  justify-content: center;
  align-items: center;
}

.installed-apps-list {
  display: flex;
}

.installed-apps li {
  display: flex;
}

.installed-apps li:hover {
  transform: translate(0px, -4px);
  z-index: 10;
}

.format-icon {
  margin-right: -8px;
  display: flex;
  align-items: center;
  overflow: hidden;
  justify-content: center;
}

.details--heading {
  width: 100%;
  text-align: center;
  border-bottom: 1px solid lightgray;
  line-height: 0.1em;
  margin: 10px 0 20px;
}

.details--heading span {
  background: #fff;
  padding: 0 10px;
  color: lightgray;
}

.board-view-btn {
  border-radius: 8px;
  width: 38px !important;
  height: 38px !important;
  display: flex;
  justify-content: center;
}

.board-view-btn.btn-active {
  background: rgba(var(--vs-primary), 1);
}

.board-view-btn.btn-inactive {
  background: transparent;
  border: 1px solid rgba(var(--vs-primary), 1);
}

.invite-user-prompt>>>.vs-dialog-cancel.vs-dialog-cancel--icon {
  display: none !important;
}

.update-user-prompt>>>.vs-dialog-cancel.vs-dialog-cancel--icon {
  display: none !important;
}

.connect-comm-server-prompt>>>.vs-dialog {
  width: 700px;
  max-width: 700px;
  height: auto;
}

.connect-comm-server-prompt>>>.vs-dialog-cancel.vs-dialog-cancel--icon {
  display: none !important;
}

.english-select>>>.vs__dropdown-option:first-child {
  border-bottom: 2px solid #efeff2;
}

.vs--searchable>>>.vs__dropdown-toggle {
  background: none !important;
  border: 2px solid #e0e0e0 !important;
}

.v-select ::v-deep .vs__dropdown-menu {
  max-height: 10rem;
  height: max-content;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.vs-dropdown--item>>>.vs-dropdown--item-link {
  display: flex;
  align-items: center;
  margin: 0.5em 0;
  padding-left: 1em;
  padding-right: 2em;
}

.con-vs-dropdown--menu {
  max-height: 17.5em;
  width: max-content;
  height: auto !important;
  overflow-y: scroll;
}

.con-vs-dropdown--menu::-webkit-scrollbar {
  width: 8px;
}

/* Track */
.con-vs-dropdown--menu::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(128, 128, 128, 0.378);
  /* border-radius: 10px; */
}

/* Handle */
.con-vs-dropdown--menu::-webkit-scrollbar-thumb {
  background: rgba(199, 195, 195, 0.658);
  border-radius: 10px;
}

.vs-input>>>.vs-input--icon {
  font-size: 1.5rem;
  color: #97a4bf !important;
}

@media only screen and (max-width: 991px) {
  .invitee-form {
    max-height: calc(100vh - 400px);
  }
}
</style>
